import { proxyCustomElement, HTMLElement, getAssetPath, h } from '@stencil/core/internal/client';
import { A as AwsService } from './index10.js';
import './index2.js';
import './index3.js';
import { I as InputType, d as defineCustomElement$4 } from './roche-input2.js';
import { M as MessageType, d as defineCustomElement$3 } from './roche-message2.js';
import { d as defineCustomElement$8 } from './roche-button2.js';
import { d as defineCustomElement$7 } from './roche-form2.js';
import { d as defineCustomElement$6 } from './roche-generic-link2.js';
import { d as defineCustomElement$5 } from './roche-icon2.js';
import { d as defineCustomElement$2 } from './roche-tooltip2.js';

var ServerResponse;
(function (ServerResponse) {
    ServerResponse[ServerResponse["IDLE"] = 0] = "IDLE";
    ServerResponse[ServerResponse["SUCCESS"] = 1] = "SUCCESS";
    ServerResponse[ServerResponse["ERROR"] = 2] = "ERROR";
})(ServerResponse || (ServerResponse = {}));

const rocheLoginCss = ":host{display:block;margin-top:3rem}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}:host .login-container{max-width:30rem;margin:0 auto}";
const RocheLoginStyle0 = rocheLoginCss;

const RocheLogin$1 = /*@__PURE__*/ proxyCustomElement(class RocheLogin extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.labelInvalidToken = 'The token you have supplied is now invalid';
        this.type = InputType.TEXT;
        this.labelUsername = 'Username';
        this.labelPassword = 'Password';
        this.labelSubmit = 'Login';
        this.error = 'Login failed';
        this.sending = false;
        this.user = null;
        this.response = ServerResponse.IDLE;
    }
    static async initAwsService() {
        if (!RocheLogin.isAwsInitialized) {
            await AwsService.init(getAssetPath('../'));
            RocheLogin.isAwsInitialized = true;
        }
    }
    static sendGlobalEvent(component) {
        if (!RocheLogin.eventFired) {
            RocheLogin.eventFired = true;
            window.dispatchEvent(new CustomEvent('rocheLoginComplete', { detail: component }));
        }
    }
    // eslint-disable-next-line class-methods-use-this
    getUrlParameter(param) {
        // eslint-disable-next-line no-useless-escape
        const replacedParam = param.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        const regex = new RegExp(`[\\?&]${replacedParam}=([^&#]*)`);
        const results = regex.exec(window.location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
    // eslint-disable-next-line class-methods-use-this
    get invalidToken() {
        return this.getUrlParameter('redirect_reason') && this.getUrlParameter('redirect_reason') === 'token_expired';
    }
    async handleSubmit({ detail }) {
        this.sending = true;
        const { username, password } = detail.values;
        const user = await AwsService.login(username, password);
        this.user = user;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.response = !user || user.challengeName === 'NEW_PASSWORD_REQUIRED'
            ? ServerResponse.ERROR
            : ServerResponse.SUCCESS;
        this.sending = false;
    }
    // eslint-disable-next-line class-methods-use-this
    async componentWillLoad() {
        await RocheLogin.initAwsService();
        if (await AwsService.isLoggedIn()) {
            // TODO set other state variables
            RocheLogin.sendGlobalEvent(this);
        }
    }
    componentDidUpdate() {
        if (this.response === ServerResponse.SUCCESS) {
            RocheLogin.sendGlobalEvent(this);
        }
    }
    render() {
        const disabled = this.sending || this.response === ServerResponse.SUCCESS;
        return (h("div", { key: 'a152f67b55272ecb5af22f7abd9215b0a6fcece2', class: "login-container" }, this.response === ServerResponse.ERROR && (h("roche-message", { text: this.error, type: MessageType.FAIL })), this.invalidToken && (h("roche-message", { text: this.labelInvalidToken, type: MessageType.FAIL })), h("roche-form", { key: 'f27919fc1f3b937506c5e1ef50c4e86c5e0dd360', submit: this.labelSubmit, disabled: disabled, "disable-submit": true, "disable-recaptcha": true }, h("roche-input", { key: '36c64d4308f7a18b5122dde0d943da50af63b497', label: this.labelUsername, type: this.type, name: "username", required: true }), h("roche-input", { key: 'd2bc5c8f62a0a4c9855e336bab1b35329f9cf089', label: this.labelPassword, type: InputType.PASSWORD, name: "password", required: true }))));
    }
    static get style() { return RocheLoginStyle0; }
}, [1, "roche-login", {
        "labelInvalidToken": [1, "label-invalid-token"],
        "type": [1],
        "labelUsername": [1, "label-username"],
        "labelPassword": [1, "label-password"],
        "labelSubmit": [1, "label-submit"],
        "error": [1],
        "sending": [32],
        "user": [32],
        "response": [32]
    }, [[0, "rocheFormSubmit", "handleSubmit"]]]);
RocheLogin$1.isAwsInitialized = false;
RocheLogin$1.eventFired = false;
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-login", "roche-button", "roche-form", "roche-generic-link", "roche-icon", "roche-input", "roche-message", "roche-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-login":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheLogin$1);
            }
            break;
        case "roche-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "roche-form":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "roche-generic-link":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "roche-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "roche-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "roche-message":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "roche-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const RocheLogin = RocheLogin$1;
const defineCustomElement = defineCustomElement$1;

export { RocheLogin, defineCustomElement };

//# sourceMappingURL=roche-login.js.map